
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangle, Info } from "lucide-react";
import { ToneValidationResult } from "@/utils/tone-validation";

interface ToneValidationAlertProps {
  validation: ToneValidationResult;
  onProceed?: () => void;
  onCancel?: () => void;
}

const ToneValidationAlert = ({ validation, onProceed, onCancel }: ToneValidationAlertProps) => {
  if (validation.isValid) return null;
  
  const isBlocked = validation.issues.includes('threats');
  
  return (
    <Alert variant={isBlocked ? "destructive" : "default"} className="mb-4">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>
        {isBlocked ? "Content Not Allowed" : "Tone Suggestion"}
      </AlertTitle>
      <AlertDescription className="space-y-2">
        <div>
          {isBlocked 
            ? "We cannot generate content with threats or harmful language."
            : "We've detected some language that might not be effective with customer service:"
          }
        </div>
        
        {validation.suggestions.length > 0 && (
          <ul className="list-disc list-inside space-y-1">
            {validation.suggestions.map((suggestion, index) => (
              <li key={index} className="text-sm">{suggestion}</li>
            ))}
          </ul>
        )}
        
        {!isBlocked && validation.filteredContent && (
          <div className="mt-3 p-2 bg-muted rounded text-sm">
            <div className="flex items-center gap-2 mb-1">
              <Info className="h-3 w-3" />
              <span className="font-medium">Suggested alternative:</span>
            </div>
            <div className="italic">{validation.filteredContent}</div>
          </div>
        )}
      </AlertDescription>
    </Alert>
  );
};

export default ToneValidationAlert;
